
import { useEffect, useMemo, useState } from "react"
import Box from "@mui/material/Box"
// import Image from 'next/legacy/image';
// import "./Home.module.css"
import dynamic from "next/dynamic"
import Image from "next/image"
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import { count, s3Url } from "../../../config/helpers"
import { useSelector } from "react-redux"
import useGlobalSettings from "@components/_hooks/useGlobalSettings";
import debounce from "@components/config/debounce";

const IsEcoFriendlyImage = dynamic(() => import('../../CategoryComponent/Products/IsEcoFriendlyImage'), {
	ssr: false,
})

const ProductImageBlock4 = (props) => {
	const {
		product_extra_media,
		thumbnail_images,
		product,
		//     price_breaks,
		// long_term_product
		extra_image_set = null,
		ecoLeaf = false
	} = props;

	const { user } = useSelector((state) => state.authReducer);
	const [nav1, setNav1] = useState(null);
	const [nav2, setNav2] = useState(null);
	const [slider1, setSlider1] = useState(null);
	const [slider2, setSlider2] = useState(null);

	const [sliderImages, setSliderImages] = useState(
		product_extra_media.extra_image_zoom
	);

	const { getSetting } = useGlobalSettings()

	useEffect(() => {
		setNav1(slider1);
		setNav2(slider2);

	});

	const debouncedSliderUpdate = useMemo(() => {
		// Debounce the slider so it always updates to the last one
		return debounce((currentExtraImage, thumbnails, sliderMain, sliderThumb) => {
			if (currentExtraImage && thumbnails && sliderMain) {
				const newIndex = thumbnails.findIndex((img) => img === currentExtraImage);
				if (newIndex !== -1) {
					sliderMain.slickGoTo(newIndex);
					if (sliderThumb) {
						sliderThumb.slickGoTo(newIndex);
					}
				}
			}
		}, 300);
	}, []);

	useEffect(() => {
		// Set the thumbnail images with the new images loaded
		if (Array.isArray(thumbnail_images)) {
			if (thumbnail_images.length != 0) {
				setSliderImages([...thumbnail_images]);
			}
		}
	}, [thumbnail_images]);

	useEffect(() => {
		debouncedSliderUpdate(extra_image_set, thumbnail_images, slider1, slider2);
	}, [extra_image_set, thumbnail_images, slider1, slider2, debouncedSliderUpdate]);

	const settingsMain = {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		// fade: typeof window == 'undefined' ? false : true,
		dotsClass: "slick-dots slick-thumb",
		// infinite: true,
		// dots: isMobile ? true : false,,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					dots: true,
				}
			},
		],
		speed: 500,
	};

	const settingsThumbs = {
		infinite: count(product_extra_media.extra_image_zoom) > 4 ? true : false,
		dots: false,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					arrows: false,
				}
			},
		],
		slidesToScroll: 1,
		draggable: true,
		asNavFor: '.slider-for',
		swipeToSlide: true,
		focusOnSelect: true,
		// nextArrow: <SampleNextArrow />,
		// prevArrow: <SamplePrevArrow />,
		centerMode: true,
		arrows: false
	};



	return (
		<Box
			className="position-relative slider-wrapper h-100 mb-2 p-0"
			sx={{
				marginBottom: 30,
				display: 'inline',
				'.slick-slider': {
					padding: 0
				}
			}}
		>
			<Box sx={{
				width: '95%',
				'@media (max-width: 780px)': {
					width: '100%',
				},
			}}>
				<Slider
					{...settingsMain}
					asNavFor={nav2}
					ref={slider => (setSlider1(slider))}
				>
					{sliderImages.map((img, idx) => (

						<Box
							className="slick-slide position-relative h-100 p-0" key={idx} style={{ position: 'unset' }} sx={{ border: 'none', outline: 'none' }}>
							<meta itemProp="image" content={product.image} />
							<Image
								className="slick-slide-image pointer"
								style={{ objectFit: 'contain', width: '100%', position: 'relative', height: 'unset' }}
								src={s3Url(img)}
								// fill
								quality={100}
								width={500}
								height={500}
								// objectFit="fill"
								alt={product.product_name}
								priority={idx == 0 ? true : false}
								sizes="30vw"
							/>

							{getSetting('carbon_footprint', 'no') == 'yes' && ecoLeaf &&
								<IsEcoFriendlyImage />
							}
						</Box>
					))}

				</Slider>
			</Box>

			<Box className=' pt-0 pb-0 pl-4' sx={{ overflow: 'hidden' }}>
				<Box className="thumbnail-slider-wrap">
					<Slider
						{...settingsThumbs}
						asNavFor={nav1}
						ref={sliderthumbs => (setSlider2(sliderthumbs))}
					>
						{sliderImages.map((img, idx) => (
							<div className="slick-slide" key={idx}>
								<Image style={{ objectFit: 'cover', height: 'fit-content', padding: 0, width: '90%', }}
									className="slick-slide-image pointer"
									src={img}
									quality={100}
									width={10}
									height={10}
									alt={product.product_name}

									priority={idx == 0 ? true : false}
									loading={idx == 0 ? 'eager' : 'lazy'}
									sizes="10vw"
								/>
							</div>
						))}
					</Slider>
				</Box>
			</Box>
		</Box>
	)
}


export default ProductImageBlock4